import _objectWithoutProperties from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["children"];
var _templateObject;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { COMMON, TYPOGRAPHY } from './constants';
import useMouseIntent from './hooks/useMouseIntent';
import theme from './theme';
var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  * { box-sizing: border-box; }\n  body { margin: 0; }\n  table { border-collapse: collapse; }\n  body.intent-mouse {\n    [role=\"button\"]:focus,\n    [role=\"tabpanel\"][tabindex=\"0\"]:focus,\n    button:focus,\n    summary:focus,\n    a:focus {\n      outline: none;\n      box-shadow: none;\n    }\n\n    [tabindex=\"0\"]:focus,\n    details-dialog:focus {\n      outline: none;\n    }\n  }\n"])));
var Base = styled.div.withConfig({
  displayName: "BaseStyles__Base",
  componentId: "qvuaww-0"
})(["", ";", ";"], TYPOGRAPHY, COMMON);
function BaseStyles(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  useMouseIntent();
  return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
    "data-portal-root": true
  }), /*#__PURE__*/React.createElement(GlobalStyle, null), children);
}
BaseStyles.displayName = "BaseStyles";
BaseStyles.defaultProps = {
  color: 'gray.9',
  fontFamily: 'normal',
  lineHeight: 'default',
  theme: theme
};
export default BaseStyles;